import styled from "styled-components";
import { device } from "../../../../utils/device";

export const Prgs = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 70px;
  position: relative;
  @media ${device.mobileS} {
    margin-bottom: 10px;
    padding: 0 10px;
  }
`;
export const PrgsLeft = styled.div`
  width: 680px;
  flex-shrink: 0;
  @media ${device.mobileS} {
    width: 100%;
  }
`;
export const PrgsRight = styled.div`
  width: 490px;
  height: 520px;
  max-height: 520px;
  overflow: auto;
  flex-shrink: 0;
  border: 1px solid rgba(85, 66, 118, 0.17);
  border-radius: 8px;
  @media ${device.mobileS} {
    
  }
`;
export const PrgsRightHdr = styled.div`
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2{
    font-size: 20px;
    line-height:  30px;
    color:#272D4D;
    font-weight: 700;
  }
  @media ${device.mobileS} {
    
  }
`;